import ApplyYourPoints from "./ApplyYourPoints";

export default ApplyYourPoints;
